import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import './styles.scss';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const appTarget = import.meta.env.VITE_APP_TARGET;
const isAdmin =
  appTarget === 'admin' ||
  (!appTarget &&
    (window.location.pathname.startsWith('/admin') ||
      window.location.hostname.includes('di-artistry-admin')));
const isSalon =
  appTarget === 'di-salon' ||
  (!appTarget && !isAdmin && window.location.hostname.includes('disalon'));

const AdminPortal = lazy(() => import('./admin/AdminPortal').then((module) => ({ default: module.AdminPortal })));
const ClientSite = lazy(() => import('./di-artistry/ClientSite').then((module) => ({ default: module.ClientSite })));
const DiSalonSite = lazy(() => import('./di-salon/DiSalonSite').then((module) => ({ default: module.DiSalonSite })));
const robotsMeta = document.querySelector('meta[name="robots"]');

if (robotsMeta && isAdmin) {
  robotsMeta.setAttribute('content', 'noindex, nofollow');
}

// Di'Salon and Di'Artistry share a single index.html. When the bundle is
// the Di'Salon target, swap the document metadata so SEO and the browser
// tab reflect the salon brand instead of the bridal studio.
if (isSalon) {
  document.title = "Di'Salon | Professional Hair Salon in Montana, Pretoria";
  document
    .querySelector('meta[name="description"]')
    ?.setAttribute(
      'content',
      "Di'Salon is a professional hair salon in Montana, Pretoria offering expert hair treatments, cuts, colour, and styling."
    );
  document.documentElement.lang = 'en';
  // The page scrollbar is painted on <html>, outside the salon's `.ds-shell`
  // root, so it cannot be reached from disalon.scss. This tag lets the shared
  // stylesheet swap its colours to the salon's monochrome ones.
  document.documentElement.classList.add('theme-disalon');
}

function App() {
  if (isAdmin) return <AdminPortal />;
  if (isSalon) return <DiSalonSite />;
  return <ClientSite />;
}

root.render(
  <React.StrictMode>
    <Suspense fallback={null}>
      <App />
    </Suspense>
  </React.StrictMode>
);
